import script from "./AboutUs.vue?vue&type=script&lang=ts&setup=true"
export * from "./AboutUs.vue?vue&type=script&lang=ts&setup=true"

import "./AboutUs.vue?vue&type=style&index=0&id=63a1aa91&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63a1aa91"]])

export default __exports__